import { ColGroupDef } from '@ag-grid-community/core';
import { PpssRatingsComponent } from '../../ppss/ppss-ratings/ppss-ratings.component';
import { AgGridHelperService } from '../../services/ag-grid-helper.service';

/**
 * Return default rating column definitions for Offshore.
 * @param ppssTab ppss tab component
 * @param agGridHelperService ag grid helper service instance
 */
export function getDefaultRatingColumnDefsForOffshore(
  ppssTab: PpssRatingsComponent,
  agGridHelperService: AgGridHelperService
): ColGroupDef[] {
  return [
    {
      groupId: 'FUND',
      children: [agGridHelperService.getFundNameColDef(true)],
    },
    {
      groupId: 'CURRENCY',
      children: [agGridHelperService.getCurrencyColDef()],
    },
    {
      groupId: 'MORNINGSTAR',
      headerGroupComponent: 'ratingsGroupHeaderComponent',
      headerClass: 'ag-header-group-cell--noflex',
      headerGroupComponentParams: {
        ratingsAsOfDate: ppssTab.ratingsAsOfDate,
        isSiteIntl: ppssTab.isSiteIntl,
      },
      children: [
        agGridHelperService.getMorningStarCategoryColDef(),
        agGridHelperService.getMorningStarOverallRatingColDef(false),
        agGridHelperService.getMorningStar3yrRatingColDef(),
        agGridHelperService.getMorningStar5yrRatingColDef(),
        agGridHelperService.getMorningStar10yrRatingColDef(),
      ],
    },
  ];
}
